import { Link } from "react-router-dom";
import { Instagram, ExternalLink } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { safeHref } from "@/lib/format";
import { Wordmark } from "./Wordmark";
import { ParentLink } from "@/components/home/About";

const Col = ({ title, links }) => (
  <div className="space-y-3">
    <p className="eb-label">{title}</p>
    {links.map(([to, l]) => <Link key={to} to={to} className="block text-sm text-zinc-400 hover:text-white">{l}</Link>)}
  </div>
);

export const Footer = () => {
  const { site, pages } = useSite();
  const f = site?.footer || {};
  const p = site?.parent || {};
  return (
    <footer className="border-t border-[#27272A] bg-[#050505] mt-24" data-testid="site-footer">
      <div className="eb-container py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4 space-y-4">
          <Wordmark wide height="h-24" />
          <p className="text-zinc-300 text-sm" data-testid="footer-parent-line">{p.footer_line}</p>
          <p className="text-zinc-500 max-w-sm text-sm leading-relaxed">{site?.brand?.tagline}</p>
          <ParentLink parent={p} className="text-sm" testid="footer-parent-link" />
        </div>
        <div className="md:col-span-2"><Col title="Services" links={[["/services", "All services"], ...pages.map((x) => [`/services/${x.slug}`, x.nav_label || x.title]), ["/agency", "Agency / white-label"]]} /></div>
        <div className="md:col-span-2"><Col title="Studio" links={[["/pricing", "Pricing"], ["/work", "Work"], ["/about", "About"], ["/faq", "FAQ"], ["/apply", "Apply / Join us"]]} /></div>
        <div className="md:col-span-2 space-y-3">
          <p className="eb-label">Contact</p>
          {f.contact_email && <a href={`mailto:${f.contact_email}`} className="block text-sm text-white hover:text-[#00E5FF] break-all" data-testid="footer-email">{f.contact_email}</a>}
          {f.phone && <a href={`tel:${f.phone}`} className="block text-sm text-zinc-400" data-testid="footer-phone">{f.phone}</a>}
          {f.address && <p className="text-zinc-500 text-sm whitespace-pre-line">{f.address}</p>}
          <Link to="/enquire" className="block text-sm text-[#00E5FF]">Start a project</Link>
        </div>
        <div className="md:col-span-2 space-y-3">
          {(f.socials || []).length > 0 && <p className="eb-label">Follow</p>}
          {(f.socials || []).map((s) => {
            const Icon = /instagram\.com/i.test(s.url) ? Instagram : ExternalLink;
            return <a key={s.url} href={safeHref(s.url)} target="_blank" rel="noopener noreferrer me" className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors" data-testid={`footer-social-${s.label.toLowerCase()}`}><Icon size={16} />{s.label}</a>;
          })}
        </div>
      </div>
      <div className="eb-container py-6 border-t border-[#27272A] flex flex-col sm:flex-row justify-between gap-2 text-xs text-zinc-600">
        <span>© {new Date().getFullYear()} {f.copyright}</span>
        <span className="flex gap-4"><Link to="/privacy" className="hover:text-zinc-400">Privacy</Link><Link to="/admin" className="hover:text-zinc-400" data-testid="footer-staff-login">Staff sign-in</Link></span>
      </div>
    </footer>
  );
};
